export default {"src":"/_next/static/media/Transport.7bff1843.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};